import { Container, Point, Sprite, TextStyle, Texture } from "pixi.js";
import { AdaptiveText } from "ui-pixijs";
import { BoosterType } from "../models/data/BoosterType";
import { GameFont } from "../GameFont";
import { CommonResourcesPackage } from "../resources/CommonResourcesPackage";
import { UIButtonBase } from "./UIButtonBase";

export class BoosterButtonBase extends UIButtonBase {
    protected readonly icon: Sprite;
    protected readonly countSubstrate: Sprite;
    protected readonly countText: AdaptiveText;
    protected readonly adIcon: Sprite;
    protected readonly levelIcon: Sprite;

    public get count(): number {
        return this.value;
    }

    public set count(value: number) {
        this.value = value;
        this.countText.text = value;
        this.countText.position.set((this.countSubstrate.width - this.countText.width) * 0.5, (this.countSubstrate.height - this.countText.height) * 0.5 - 7);
        this.countSubstrate.visible = value > 0;
        this.adIcon.visible = this.isAdAvailable && !this.countSubstrate.visible;
    }

    public get level(): number {
        return this._level;
    }

    public set level(value: number) {
        this._level = value;
        this.levelIcon.texture = this.commonResources[`assets_common_boosters_levels_icons_${this.level}_png` as keyof CommonResourcesPackage] as Texture;
    }

    public get isAdRefill(): boolean {
        return this.isAdAvailable && this.count === 0;
    }

    public get flyTargetCoordinates(): Point {
        const icon = this.icon;
        const gv = this.parent.parent.parent as Container;
        const lb = icon.getLocalBounds();
        const localCenter = new Point(lb.x + lb.width / 2, lb.y + lb.height / 2);

        return gv ? gv.toLocal(localCenter, icon) : localCenter; // Convert from icon's local space to GameView's local space
    }

    public constructor(
        private readonly commonResources: CommonResourcesPackage,
        public readonly type: BoosterType,
        protected value: number,
        protected _level: number,
        private readonly isAdAvailable: boolean
    ) {
        super({ defaultTexture: commonResources.assets_common_boosters_booster_substrate_png });
        this.icon = new Sprite(commonResources[this.getBoosterTextureKey(type)] as Texture);
        this.icon.position.set((this.defaultView.width - this.icon.width) * 0.5, (this.defaultView.height - this.icon.height) * 0.5);
        this.levelIcon = new Sprite(commonResources[`assets_common_boosters_levels_icons_${_level}_png` as keyof CommonResourcesPackage] as Texture);
        this.levelIcon.position.set(120, 10);
        this.levelIcon.visible = isAdAvailable;
        this.defaultView.addChild(this.icon, this.levelIcon);

        this.countSubstrate = new Sprite(commonResources.assets_common_boosters_counter_substrate_png);
        this.countText = new AdaptiveText(value.toString(), new CountTextStyle(), 36, 40);
        this.countSubstrate.addChild(this.countText);
        this.countText.updateText(false);
        this.countText.position.set((this.countSubstrate.width - this.countText.width) * 0.5, (this.countSubstrate.height - this.countText.height) * 0.5 - 7);
        this.countSubstrate.position.set(130, 140);
        this.countSubstrate.visible = value > 0 || !isAdAvailable;

        this.adIcon = new Sprite(commonResources.assets_common_boosters_ad_substrate_png);
        this.adIcon.position.set(130, 140);
        this.adIcon.visible = this.isAdAvailable && !this.countSubstrate.visible;

        this.addChild(this.countSubstrate, this.adIcon);
    }

    private getBoosterTextureKey(booster: BoosterType): keyof CommonResourcesPackage {
        return `assets_common_boosters_${booster}_png` as keyof CommonResourcesPackage;
    }
}

export class CountTextStyle extends TextStyle {
    public constructor() {
        super({
            fontSize: 26,
            fill: "#6023BD",
            fontFamily: GameFont.Default
        })
    }
}
